/******************************************************************************
 * @preserve Copyright (c) 2012 Amazon.com, Inc. All rights reserved.         *
 ******************************************************************************/
import "./send-to-kindle-options.css";

jQuery(function ($) {
    var $S2K = window.$SendToKindle = {
        // ######## Members ########
        spinner: $(".s2k-setup-spinner"),
        
        // ######## Methods ########
        /**
         * Bootstrap closure.
         */
        bootstrap: function () {
            // Localize UI.
            $S2K.localize();
            
            // Register events.
            $S2K.registerEvents();
            
            // Set initial text.
            chrome.storage.sync.get("s2k-send-shortcut", function (items) {
                $S2K.updateShortcut(items["s2k-send-shortcut"] || undefined, $("#s2k-send"));
            });
            
            chrome.storage.sync.get("s2k-preview-shortcut", function (items) {
                $S2K.updateShortcut(items["s2k-preview-shortcut"] || undefined, $("#s2k-preview"));
            });
        },

        /**
         * Register events.
         */
        registerEvents: function () {
            $(".s2k-shortcut").on("keypress", $S2K.onSuppressEvent);
            $(".s2k-shortcut").on("keydown",  $S2K.onSuppressEvent);
            $(".s2k-shortcut").on("keyup", $S2K.onShortcut);
            $(".s2k-shortcut-remove").on("click", $S2K.onRemoveShortcut);
        },
        
        /**
         * Load localization strings and links. 
         */  
        localize: function () {
            // Localize strings.
            $.each($("[s2k-string]"), function () {
                var $n = $(this);
                $n.text(chrome.i18n.getMessage($n.attr("s2k-string")));
            });

            // Localize links.
            $.each($("[s2k-link]"), function () {
                var $n = $(this);
                $n.attr("href", chrome.i18n.getMessage($n.attr("s2k-link")));
            });

            $.each($("[s2k-setup-link]"), function () {
                var $n = $(this);
                $n.attr("href", BUILD_PROPS.__setupUrl__);
            });
        },      
        
        /**
         * Update the shortcut displayed.
         * @param shortcut  Configured Shortcut
         * @param element   UI Element
         */
        updateShortcut: function (shortcut, element) {
            var shortcutText = "";
            
            if (shortcut) {
                // Set text for control keys.
                if (shortcut.control) {
                    shortcutText +=  chrome.i18n.getMessage("kbsCtrl") + " + ";
                }
                
                if (shortcut.shift) {
                    shortcutText +=  chrome.i18n.getMessage("kbsShift") + " + ";
                }
                
                if (shortcut.alt) {
                    shortcutText +=  chrome.i18n.getMessage("kbsAlt") + " + ";
                }
                
                // Set key code.
                if (shortcut.key > 47 && shortcut.key < 91) {
                    shortcutText += String.fromCharCode(shortcut.key);
                }
                else if (shortcut.key > 36 && shortcut.key < 41) {
                    switch (shortcut.key) {
                    case 37:
                        shortcutText += chrome.i18n.getMessage("kbsArrowLeft");
                        break;
                    case 38:
                        shortcutText += chrome.i18n.getMessage("kbsArrowUp");
                        break;
                    case 39:
                        shortcutText += chrome.i18n.getMessage("kbsArrowRight");
                        break;
                    case 40:
                        shortcutText += chrome.i18n.getMessage("kbsArrowDown");
                        break;
                    }
                }
                else {
                    shortcutText += "F" + (shortcut.key - 111);
                }
            }
            
            // Set shortcut text.
            element.val(shortcutText);
        },

        /**
         * Equals operator for shortcuts.
         * @param sc1   Shortcut 1
         * @param sc2   Shortcut 2
         * @return Equals Flag
         */
        isShortcutEqual: function (sc1, sc2) {
            return (sc1 &&
                    sc2 &&
                    sc1.control === sc2.control &&
                    sc1.alt === sc2.alt &&
                    sc1.shift === sc2.shift &&
                    sc1.key === sc2.key);
        },
        
        // ######## Event Handler ########
        /**
         * Event handler to suppress propagation.
         * @param event Event
         */
        onSuppressEvent: function (event) {
            // Stop event for other handlers.
            event.preventDefault();
            event.stopPropagation();
        },
        
        /**
         * Event handler for final storing of shortcuts.
         * @param event Event
         */
        onShortcut: function (event) {
            // Stop event for other handlers.
            event.preventDefault();
            event.stopPropagation();

            // Create a shortcut.
            var shortcut = {
                "control": event.ctrlKey,
                "shift": event.shiftKey,
                "alt": event.altKey,
                "key": event.keyCode
            };
            
            // Check for a valid shortcut is CTRL, SHIFT or ALT plus a number, letter or arrow or an F-key alone.
            var isValid = ((shortcut.control || shortcut.alt || shortcut.shift) &&
                           ((shortcut.key > 47 && shortcut.key < 91) || 
                            (shortcut.key > 36 && shortcut.key < 41))) ||
                          (!(shortcut.control || shortcut.alt || shortcut.shift) &&
                            (shortcut.key > 114 && shortcut.key < 122 && shortcut.key !== 116));
            
            if (isValid) {
                // Set correct handler.
                var id = $(event.target).attr("id");
                
                // Update send shortcut.
                if (id === "s2k-send") {
                    chrome.storage.sync.get("s2k-preview-shortcut", function (items) {
                        if (!$S2K.isShortcutEqual(shortcut, items["s2k-preview-shortcut"] || undefined)) {
                            chrome.storage.sync.set({"s2k-send-shortcut": shortcut});
                            $S2K.updateShortcut(shortcut, $(event.target));
                        }
                    });
                }
                else if (id === "s2k-preview") {
                    chrome.storage.sync.get("s2k-send-shortcut", function (items) {
                        if (!$S2K.isShortcutEqual(shortcut, items["s2k-send-shortcut"] || undefined)) {
                            chrome.storage.sync.set({"s2k-preview-shortcut": shortcut});
                            $S2K.updateShortcut(shortcut, $(event.target));
                        }
                    });
                }
            }
        },
        
        /**
         * Event handler for shortcut removal. 
         */
        onRemoveShortcut: function (event) {
            var id = $(event.target).attr("id");
            if (id === "s2k-send-remove") {
                chrome.storage.sync.remove("s2k-send-shortcut");
                $S2K.updateShortcut(undefined, $("#s2k-send"));
            }
            else if (id === "s2k-preview-remove") {
                chrome.storage.sync.remove("s2k-preview-shortcut");
                $S2K.updateShortcut(undefined, $("#s2k-preview"));
            }
        }
    };
    
    // ######## Initializer ########
    $S2K.bootstrap();
});
